import { adminActionTypes } from "src/action_types/section_action_types";

export function selectedPartnerReducer(state = "", action) {
  switch (action.type) {
    case adminActionTypes.selectedPartner:
      return action.payload;
    default:
      return state;
  }
}
